import { useQuery } from '@tanstack/react-query';

import { CMS_QUERY_KEY } from '../../constants';
import { loadContentSlotData } from './api';

export const useContentSlotQuery = (identifier: string) => {
    return useQuery({
        queryKey: [CMS_QUERY_KEY.CONTENT_SLOT, identifier],
        queryFn: () => loadContentSlotData(identifier),
        enabled: !!identifier,
    });
};
